
export default function ServiceArea() {
  const scrollToForm = () => {
    const formSection = document.getElementById('contact-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const locations = [
    {
      name: 'Los Angeles',
      icon: 'ri-building-line',
      image: 'https://public.readdy.ai/ai/img_res/9e0a87aed95f24bc4d2f2ff2d9510b9f.jpg'
    },
    {
      name: 'San Diego',
      icon: 'ri-ship-line',
      image: 'https://readdy.ai/api/search-image?query=San%20Diego%20waterfront%20with%20harbor%20and%20boats%2C%20beautiful%20coastal%20city%20view%2C%20sunny%20California%20beach%20town%2C%20clear%20sky%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=400&height=300&seq=sd-city-001&orientation=landscape'
    },
    {
      name: 'Las Vegas',
      icon: 'ri-hotel-line',
      image: 'https://readdy.ai/api/search-image?query=Las%20Vegas%20strip%20with%20famous%20hotels%20and%20casinos%2C%20iconic%20Nevada%20entertainment%20district%2C%20bright%20lights%2C%20desert%20city%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=400&height=300&seq=vegas-city-001&orientation=landscape'
    },
    {
      name: 'San Francisco',
      icon: 'ri-road-map-line',
      image: 'https://readdy.ai/api/search-image?query=San%20Francisco%20Golden%20Gate%20Bridge%20with%20bay%20view%2C%20iconic%20California%20landmark%2C%20red%20bridge%20against%20blue%20sky%2C%20coastal%20scenery%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=400&height=300&seq=sf-city-001&orientation=landscape'
    },
    {
      name: 'Phoenix',
      icon: 'ri-sun-line',
      image: 'https://readdy.ai/api/search-image?query=Phoenix%20Arizona%20desert%20landscape%20with%20cacti%20and%20mountains%2C%20southwestern%20United%20States%20scenery%2C%20clear%20blue%20sky%2C%20arid%20landscape%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=400&height=300&seq=phoenix-city-001&orientation=landscape'
    },
    {
      name: 'Grand Canyon',
      icon: 'ri-landscape-line',
      image: 'https://readdy.ai/api/search-image?query=Grand%20Canyon%20national%20park%20with%20dramatic%20red%20rock%20formations%20and%20vast%20canyon%20views%2C%20iconic%20Arizona%20natural%20wonder%2C%20clear%20sky%2C%20majestic%20landscape%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=400&height=300&seq=gc-park-001&orientation=landscape'
    },
    {
      name: 'Antelope Canyon',
      icon: 'ri-contrast-2-line',
      image: 'https://readdy.ai/api/search-image?query=Antelope%20Canyon%20slot%20canyon%20with%20smooth%20sandstone%20walls%20and%20light%20beams%2C%20Arizona%20natural%20wonder%2C%20orange%20and%20red%20rock%20formations%2C%20unique%20geological%20formation%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=400&height=300&seq=antelope-park-001&orientation=landscape'
    },
    {
      name: 'Utah Parks',
      icon: 'ri-mountain-line',
      image: 'https://readdy.ai/api/search-image?query=Utah%20national%20parks%20with%20red%20rock%20arches%20and%20dramatic%20formations%20at%20Zion%20or%20Bryce%20Canyon%2C%20stunning%20southwestern%20landscape%2C%20clear%20blue%20sky%2C%20majestic%20scenery%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=400&height=300&seq=utah-parks-001&orientation=landscape'
    },
    {
      name: 'Yosemite',
      icon: 'ri-tree-line',
      image: 'https://readdy.ai/api/search-image?query=Yosemite%20National%20Park%20with%20granite%20cliffs%20and%20waterfalls%2C%20California%20natural%20wonder%2C%20dramatic%20mountain%20scenery%2C%20clear%20sky%2C%20pristine%20wilderness%2C%20clean%20simple%20background%2C%20professional%20travel%20photography&width=400&height=300&seq=yosemite-park-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Địa Bàn Phục Vụ – Các Tuyến Điểm Mạnh
          </h2>
          <p className="text-lg sm:text-xl text-gray-700 max-w-3xl mx-auto font-medium">
            Tập trung mạnh tại miền Tây Hoa Kỳ với các điểm đến nổi tiếng
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {locations.map((location, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={location.image}
                  alt={location.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-5 sm:p-6">
                <div className="flex items-center">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-blue-900 text-white rounded-lg mr-4">
                    <i className={`${location.icon} text-xl sm:text-2xl`}></i>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
                    {location.name}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={scrollToForm}
            className="whitespace-nowrap bg-blue-900 hover:bg-blue-800 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg text-base sm:text-lg font-bold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            <i className="ri-send-plane-line mr-2 text-xl"></i>
            Gửi lịch trình – Nhận báo giá ngay
          </button>
        </div>
      </div>
    </section>
  );
}
